import { FEATURE_NAME } from './consts';

export const UPDATE_CONTACTS = `${FEATURE_NAME}/UPDATE_CONTACTS`;
